import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const AppsPage = lazy(() => import("@/pages/AppsPage"));
const AppProductPage = lazy(() => import("@/pages/AppProductPage"));
import { ChatWidget } from "@/components/ChatWidget";
import { CartDrawer } from "@/components/CartDrawer";
import { BookRequestModal } from "@/components/BookRequestModal";
import { AmbientBackground } from "@/components/AmbientBackground";
import { CookieBanner } from "@/components/CookieBanner";
import { trackVisit } from "@/api";
import Home from "@/pages/Home";
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Legal = lazy(() => import("@/pages/Legal"));
const ProductPage = lazy(() => import("@/pages/ProductPage"));
const Checkout = lazy(() => import("@/pages/Checkout"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentResult").then((m) => ({ default: m.PaymentSuccess })));
const PaymentCancel = lazy(() => import("@/pages/PaymentResult").then((m) => ({ default: m.PaymentCancel })));
const CustomerPanel = lazy(() => import("@/pages/CustomerPanel"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const Admin = lazy(() => import("@/pages/admin/Admin"));

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => { trackVisit(); }, []);

  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname]);

  // powrót z maila propozycji (rezygnacja) -> od razu otwórz czat z Booki, żeby dokończyć rozmowę
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("booki") !== "1") return;
    window.dispatchEvent(new Event("open-book-request"));
    params.delete("booki");
    const rest = params.toString();
    window.history.replaceState({}, "", location.pathname + (rest ? `?${rest}` : "") + location.hash);
  }, [location.search, location.pathname, location.hash]);

  return (
    <>
      <AmbientBackground />
      <div className="relative z-[1]">
        {!isAdmin && <Navbar />}
        <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/produkt/:id" element={<ProductPage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/regulamin" element={<Legal page="regulamin" />} />
          <Route path="/polityka-prywatnosci" element={<Legal page="polityka-prywatnosci" />} />
          <Route path="/wysylka" element={<Legal page="wysylka" />} />
          <Route path="/platnosci" element={<Legal page="platnosci" />} />
          <Route path="/platnosc/sukces" element={<PaymentSuccess />} />
          <Route path="/platnosc/anulowana" element={<PaymentCancel />} />
          <Route path="/konto" element={<CustomerPanel />} />
          <Route path="/o-nas" element={<AboutPage />} />
          <Route path="/aplikacje" element={<AppsPage />} />
          <Route path="/aplikacje/:id" element={<AppProductPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        </Suspense>
        {!isAdmin && <Footer />}
      </div>
      {!isAdmin && <CartDrawer />}
      <BookRequestModal />
      <ChatWidget />
      <CookieBanner />
      <Toaster position="top-center" theme="dark" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-slate-950">
      <BrowserRouter>
        <CartProvider>
          <Layout />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
